<mat-toolbar class="app-toolbar">

  <!-- Hamburger: mobile only -->
  <button mat-icon-button class="hamburger-btn" [matMenuTriggerFor]="mymenu" aria-label="Open navigation menu">
    <mat-icon>menu</mat-icon>
  </button>

  <mat-menu #mymenu="matMenu">
    <ng-container *ngFor="let item of currentMenuItems">
      <button mat-menu-item *ngIf="item.showOnMobile" [routerLink]="item.routerlink">
        <mat-icon>{{item.icon}}</mat-icon>
        <span>{{item.label}}</span>
      </button>
    </ng-container>
    <mat-divider *ngIf="user"></mat-divider>
    <button mat-menu-item *ngIf="user" (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Logout</span>
    </button>
  </mat-menu>

  <!-- Logo -->
  <a routerLink="/home" class="toolbar-brand">
    <img src="./assets/logo.png" class="toolbar-logo" alt="Paul & Sons logo">
  </a>

  <!-- Desktop nav -->
  <nav class="desktop-nav" aria-label="Main navigation">
    <ng-container *ngFor="let item of currentMenuItems">
      <button mat-button class="nav-btn"
              *ngIf="item.showOnDesktop || item.showOnTablet"
              [routerLink]="item.routerlink"
              routerLinkActive="nav-active">
        <mat-icon class="nav-icon">{{item.icon}}</mat-icon>
        <span>{{item.label}}</span>
      </button>
    </ng-container>
  </nav>

  <span class="toolbar-spacer"></span>

  <!-- Role badge + user info -->
  <div *ngIf="user" class="user-section">
    <span class="role-badge" [class.role-provider]="isProvider()" [class.role-customer]="isCustomer()">
      {{ isProvider() ? 'Provider' : 'Customer' }}
    </span>
    <span class="welcome-text">{{ user.username }}</span>
    <button mat-icon-button routerLink="/edit-account" matTooltip="My Account">
      <mat-icon>manage_accounts</mat-icon>
    </button>
    <button mat-icon-button class="logout-btn" (click)="logout()" matTooltip="Logout">
      <mat-icon>logout</mat-icon>
    </button>
  </div>

  <!-- Guest login button -->
  <div *ngIf="!user" class="user-section">
    <a routerLink="/auth">
      <button mat-stroked-button class="login-btn">Login / Sign Up</button>
    </a>
  </div>

</mat-toolbar>
